function IconEmailComponent() {
  return (
    <svg
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.93853 1H11.2935C11.6032 1.00105 11.9 1.12455 12.119 1.34356C12.338 1.56256 12.4615 1.85929 12.4625 2.169V9.185C12.4615 9.49471 12.338 9.79144 12.119 10.0104C11.9 10.2294 11.6032 10.3529 11.2935 10.354H1.93853C1.62899 10.3529 1.33241 10.2296 1.11344 10.0108C0.894466 9.79201 0.770849 9.49554 0.769531 9.186V2.169C0.770586 1.85929 0.894086 1.56256 1.11309 1.34356C1.33209 1.12455 1.62882 1.00105 1.93853 1V1Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4635 2.16895L6.61653 6.26195L0.769531 2.16895"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export { IconEmailComponent };
